import { Grid } from "@mui/material";
import { isSameMonth, isWithinInterval, setMonth } from "date-fns";
import React from "react";
import MonthItem from "./MonthItem";

const MonthCalendar = ({ dateFormater, year, onChange, value }) => {
	const months = [];

	for (let month = 0; month < 12; month++) {
		months.push(setMonth(year, month));
	}

	return (
        <Grid container sx={{ width: 320 }}>
            {months.map((month) => {
				const monthStr = dateFormater(month, "MMM");
				const isFirst = isSameMonth(month, value[0]);
				const isLast = isSameMonth(month, value[1]);

				const isSelected = isWithinInterval(month, {
					start: value[0],
					end: value[1],
				});

				return (
                    <Grid key={monthStr} size={4}>
                        <MonthItem
							selected={isSelected}
							isFirst={isFirst}
							isLast={isLast}
							month={monthStr}
							onClick={() => {
								onChange(month);
							}}
						/>
                    </Grid>
                );
			})}
        </Grid>
    );
};

export default MonthCalendar;
